/*目前直播间，预告，回放页定制化混入，不要随意改J_prismPlayer_liveDetails的class*/
export default {
  methods: {
    fitVideo() {
      let video = document.querySelector('video');
      let preVideo = document.querySelector('.pre-video');
      let screenWidth = document.documentElement.clientWidth
      let screenHeight = document.documentElement.clientHeight
      let videoWidth = video.videoWidth;
      let videoHeight = video.videoHeight;
      let screenProportion = screenWidth/screenHeight;
      let videoProportion = videoWidth/videoHeight;
      console.log(screenWidth, screenHeight, videoWidth, videoHeight)
      console.log(videoProportion, screenProportion)
      if (videoProportion >= screenProportion) {
        preVideo.setAttribute('class', 'pre-video prism-player aliplayer-contain')
      } else {
        preVideo.setAttribute('class', 'pre-video prism-player aliplayer-cover')
      }
    },
  }
}
